import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TriviaGame from './TriviaGame';
import CountdownModal from './CountdownModal';
import { GameMode } from '../types/game';

interface GamePageProps {
  userTier: 'FREE' | 'PREMIUM' | 'VIP';
  onUpgrade: (tier: 'PREMIUM' | 'VIP') => void;
  gameMode?: GameMode;
  dailyQuestionIds?: number[];
  // Authenticated wallet (SIWE). When set, the game's final result is recorded
  // to the leaderboard; null/undefined players play without being ranked.
  authedAddress?: string | null;
}

const GamePage: React.FC<GamePageProps> = ({
  userTier,
  onUpgrade,
  gameMode = 'STANDARD',
  dailyQuestionIds,
  authedAddress,
}) => {
  const [showCountdown, setShowCountdown] = useState(true);
  const [gameReady, setGameReady] = useState(false);
  const navigate = useNavigate();

  const handleCountdownComplete = () => {
    setShowCountdown(false);
    setGameReady(true);
  };

  const handleGameExit = () => {
    navigate('/');
  };

  return (
    <div className="game-page">
      {showCountdown && (
        <CountdownModal
          isOpen={showCountdown}
          onComplete={handleCountdownComplete}
          startCount={3}
        />
      )}

      {gameReady && (
        <TriviaGame
          userTier={userTier}
          onUpgrade={onUpgrade}
          gameMode={gameMode}
          dailyQuestionIds={dailyQuestionIds}
          authedAddress={authedAddress}
        />
      )}
    </div>
  );
};

export default GamePage;
